import { get, post, remove } from "../common/http.services";

export function searchCosting(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/costing/search/?page=${pageNumber}&size=${pageSize}&sort=creationDate,desc`, searchData, appContext, success, error);
}

export function saveCosting(costingModel: any, appContext: any, success: any, error: any) {
    return post(`/costing`, costingModel, appContext, success, error);
}

export function duplicateCosting(costingId: any, appContext: any, success: any, error: any) {
    return post(`/costing/duplicate?costingId=${costingId}`, null, appContext, success, error);
}

export function copyCosting(costingId: any, enqProductId: any, appContext: any, success: any, error: any) {
    return post(`/costing/copy?costingId=${costingId}&enqProductId=${enqProductId}`, null, appContext, success, error);
}

export function getCostingDetail(costingId: any, appContext: any, success: any, error: any) {
    return get(`/costing/detail?costingId=${costingId}`, appContext, success, error);
}

export function getDetailVersions(costingId: any, appContext: any, success: any, error: any) {
    return get(`/costing/detail/versions?costingId=${costingId}`, appContext, success, error);
}

export function getDetailByVersion(costingId: any, version: any, appContext: any, success: any, error: any) {
    return get(`/costing/detailbyversion?costingId=${costingId}&version=${version}`, appContext, success, error);
}

export function deleteCosting(id: any, appContext: any, success: any, error: any) {
    return remove(`/costing?id=${id}`, appContext, success, error);
}

export function getCostingDataById(id: any, appContext: any, success: any, error: any) {
    return get(`/costing/findbyid?id=${id}`, appContext, success, error);
}

export function getCostingQualityData(orderId: any, costingId: any, appContext: any, success: any, error: any) {
    return get(`/costing/getqualitydata?orderId=${orderId}&costingId=${costingId}`, appContext, success, error);
}

export function getCostingDataByCode(code: any, appContext: any, success: any, error: any) {
    return get(`/costing/findbycode?code=${code}`, appContext, success, error);
}

export function getEnquiryCosting(code: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/costing/findbyenquirycode?enquiryCode=${code}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getProductCosting(id: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/costing/findbyproductid?enqProductId=${id}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function getSplit(costSearchModel: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/costing/split?page=${pageNumber}&size=${pageSize}`, costSearchModel, appContext, success, error);
}
